import { Pagination } from '@/services/request/request.types';
import { paginationResponseTransformer } from '@/utils/pagination/pagination';
import { AxiosResponse } from 'axios';
import { deleteRequest, getRequest } from '../request/request.service';
import {
  CallLogParams,
  CallsResponse,
  EsTrendingTopicsResponse,
  ExportCallLogsResponse,
  ExportHistory,
  ExportHistoryParams,
  TrendingTopicsParams,
} from './call-log-service.types';

export const CALL_LOG_URL = 'conversations';
const SEARCH_CALL_LOG_URL = 'search/conversations';

export function isElasticSearchEnabled(): boolean {
  return new URLSearchParams(window.location.search).get('search') === 'es';
}

function esResponseTransformer<T extends { pagination: Pagination }>(
  response: AxiosResponse
): T {
  const data = response.data;
  const totalCount = data.calls_count || 0;
  const totalCountRelation = data.calls_count_relation || 'eq';
  const pageItems = data.calls?.length || 0;
  const page = Number(response.config?.params?.page) || 1;
  const itemsPerPage = Number(response.config?.params?.items_per_page) || 25;
  const totalPages = itemsPerPage > 0 ? Math.ceil(totalCount / itemsPerPage) : 0;

  return {
    ...data,
    pagination: { totalCount, totalCountRelation, currentPage: page, pageItems, totalPages },
  };
}

export function getCallLog(params: CallLogParams) {
  const isEs = isElasticSearchEnabled();
  const url = isEs ? SEARCH_CALL_LOG_URL : CALL_LOG_URL;
  const transformer = isEs ? esResponseTransformer : paginationResponseTransformer;
  return getRequest<CallsResponse>(url, { params }, transformer);
}

export function getExportHistory(params: ExportHistoryParams) {
  return getRequest<ExportHistory>(`${CALL_LOG_URL}/csv_files`, { params });
}

export function getExportHistoryFile(id: number) {
  return getRequest<{ file: string }>(`${CALL_LOG_URL}/${id}/download_csv`);
}

export function getExportCallLogs(params: CallLogParams) {
  return getRequest<ExportCallLogsResponse>(`${CALL_LOG_URL}/export_calls`, {
    params,
  });
}

export function getTrendingTopics(params: TrendingTopicsParams) {
  const url = isElasticSearchEnabled() ? SEARCH_CALL_LOG_URL : CALL_LOG_URL;
  return getRequest<string[]>(`${url}/trending_topics`, {
    params,
  });
}

export function getEsTrendingTopics(params: TrendingTopicsParams) {
  return getRequest<EsTrendingTopicsResponse>(`${SEARCH_CALL_LOG_URL}/es_trending_topics`, {
    params,
  });
}

export function deleteExportHistoryPendingFile(id: number) {
  return deleteRequest(`${CALL_LOG_URL}/${id}/delete_file`);
}
